import mq from '../../../../../commons/styles/mediaQueries';
import styled from '../../../../../theme/styled';

const SafeDealActionsInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 16px;

  ${mq.desktop} {
    flex-direction: row;
    align-items: center;
    gap: 10px;
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
  }
`;

export default {
  SafeDealActionsInfoBlock,
};
